import "@/App.css";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BookingEngine from "@/components/BookingEngine";
import Marquee from "@/components/Marquee";
import RoomsSection from "@/components/RoomsSection";
import ExperiencesSection from "@/components/ExperiencesSection";
import FoodBarSection from "@/components/FoodBarSection";
import EventsSection from "@/components/EventsSection";
import SocialProof from "@/components/SocialProof";
import LocationSection from "@/components/LocationSection";
import CommunityCTA from "@/components/CommunityCTA";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

function App() {
  useLenis();
  const goBook = () => scrollToId("booking");
  const goExperience = () => scrollToId("experiences");

  return (
    <div className="App dark min-h-screen bg-[#0a0a0a] text-neutral-100">
      <Navbar onBook={goBook} />
      <main>
        <Hero onBook={goBook} onExplore={goExperience} />
        <BookingEngine />
        <RoomsSection />
        <Marquee />
        <ExperiencesSection />
        <FoodBarSection />
        <EventsSection />
        <SocialProof />
        <LocationSection />
        <CommunityCTA />
        <FinalCTA onBook={goBook} />
      </main>
      <Footer />
      <StickyMobileCTA onBook={goBook} />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#171717",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
